import { render, staticRenderFns } from "./common-channel.vue?vue&type=template&id=596dc2e3&"
import script from "./common-channel.vue?vue&type=script&lang=js&"
export * from "./common-channel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports